import { render, staticRenderFns } from "./BookPreview.vue?vue&type=template&id=b6e8ebf4"
import script from "./BookPreview.vue?vue&type=script&lang=js"
export * from "./BookPreview.vue?vue&type=script&lang=js"
import style0 from "./BookPreview.vue?vue&type=style&index=0&id=b6e8ebf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports